<template>
    <section id="welcome-platform">
        <b-modal id="welcome-platform-modal" ref="welcomePlatform" centered hide-header hide-footer>
            <div class="welcome-platform mx-auto d-flex justify-content-center align-items-center position-relative">
                <button 
                    @click="$bvModal.hide('welcome-platform-modal')" 
                    aria-label="Close" 
                    id="modal-close"
                    class="close pr-2">
                        <CloseCross />
                </button>
                <div class="modal-container-wrap">
                    <div class="text-center">
                        <WelcomeIcon class="mb-3"/>
                        <p class="c23 p1n mb-0">Welcome to the platform!</p>
                        <p class="c23 p1n mb-0">We are excited to have you here.</p>                        
                    </div>
                    <button 
                        @click="backToHome" 
                        class="c16 p2b phiolet_button mt-3">
                            Cool!
                    </button>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import {
        GoogleIcon,
        CloseCross,
        WelcomeIcon
    } from '../components/Icons'
    export default {
        name: 'WelcomePlatform',
        components: {
            GoogleIcon,
            CloseCross,
            WelcomeIcon
        },
        methods: {
            backToHome: function () {
                this.$bvModal.hide('welcome-platform-modal')
            }

        }
    }
</script>

<style scoped lang="scss">
    div.welcome-platform {
        width: 450px;
        height: 325px;
        background: #FFFFFF;
        box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
        border-radius: 5px;

        div.modal-container-wrap {
            width: 325px;
            height: 213px;

            button {
                width: 100%;
                height: 48px;

                &:first-child {
                    background: #F4F4F4;
                    border-radius: 5px;
                    transition: all 0.2s ease;

                    &:hover {
                        box-shadow: 0px 4px 8px #858585;
                    }
                }
            }
        }
    }
</style>